export const STRUCTURE_RESPONSIBLES_LOAD_ERROR = 'No fue posible cargar responsables';

export class StructureResponsiblesLoadError extends Error {
    constructor(cause?: unknown) {
        super(STRUCTURE_RESPONSIBLES_LOAD_ERROR);
        this.name = 'StructureResponsiblesLoadError';
        if (cause !== undefined) this.cause = cause;
    }
}

export const requireStructureResponsibleRecords = <T extends Record<string, unknown>>(
    records: T[] | null | undefined,
    source: string
): T[] => {
    if (!Array.isArray(records)) {
        throw new StructureResponsiblesLoadError(`${source}: invalid response`);
    }

    if (records.some(record => !Object.prototype.hasOwnProperty.call(record, 'president_name'))) {
        throw new StructureResponsiblesLoadError(`${source}: president_name missing`);
    }

    return records;
};

export const resolveStructureResponsibleName = (value: unknown): string | null => {
    if (typeof value !== 'string') return null;
    const name = value.trim();
    if (!name || ['sin asignar', 'n/a'].includes(name.toLowerCase())) return null;
    return name;
};

export const getStructureResponsibleLabel = (
    value: unknown,
    emptyLabel: 'Sin Asignar' | 'N/A' = 'Sin Asignar'
): string => resolveStructureResponsibleName(value) || emptyLabel;
